

















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";
import EventApi from "../../api/EventsApi";
import PixiScene from "../../libs/table-hand/api/render/PixiScene";

@Component({
    components: {},
    props: {},
})

export default class RestartGameModal extends Vue {
    /**
     * Стейт игры
     * @private
     */
    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * Закрыть модалку
     * @private
     */
    private closeModal(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('close');
    }

    /**
     * Перезапустить игру
     */
    private restartGame(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        window.PixiScene?.restartGame();
        const data = {
            contentPackId: this.gameState.tasks.state.content_pack_id,
            setId: 1,
            activityId: this.gameState.tasks.state.activity_id,
            playAgain: true,
        };
        this.$emit('restart', 'getContentPackTasks', data);
        this.closeModal();
        EventApi.triggerEvent(EventApi.SHOW_TABLE_LOADER);
    }
}
